import ClaimJobItemPayee from 'models/claims/claimJobItemPayee/Model.ClaimJobItemPayee';
import MediaFile from 'models/core/mediaFile/Model.MediaFile';
import User from 'models/core/user/Model.User';
import Model from 'models/Model';
import ClaimJobPaymentItem from '../claimJobPaymentItem/Model.ClaimJobPaymentItem';
import PostingAccount from '../postingAccount/Model.PostingAccount';
import claimJobPaymentCancelApi from './cancel/Api.ClaimJobPayment.Cancel';
import claimJobPaymentFindApi from './find/Api.ClaimJobPayment.Find';
import claimJobPaymentListApi from './list/Api.ClaimJobPayment.List';

export default class ClaimJobPayment
  extends Model<Model.IClaimJobPayment>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IClaimJobPayment>
{
  id: number;
  amountPaid: number = 0;
  gstHstAmountPaid: number = 0;
  provincialSalesTaxAmountPaid: number = 0;
  deduction: number = 0.0;

  readonly totalTaxPaid: number;
  readonly totalBeforeTax: number;

  currency: string = 'CAD';
  explanation: string;
  referenceNumber: string;
  status: string;
  createdAtLocal: string;
  createdAtUtc: string;
  modifiedAtUtc: string;
  transactionDateUtc: string;
  paymentDateUtc: string;
  paymentMethodCode: string;

  bankTransit: string;
  bankBranch: string;
  bankAccount: string;

  chequeNumber: string;

  transactionNumber: string;
  paymentEmailAddress: string;
  remittanceEmailAddress: string;
  isAutoDepositEnabled: boolean;
  eTransferQuestion: string;
  eTransferAnswer: string;

  isCancelled: boolean;

  claimJobPaymentItems: ClaimJobPaymentItem[];
  claimJobPaymentPayee?: ClaimJobItemPayee;
  ownerId?: number;
  owner?: User;
  ledgerAccountId?: number;
  ledgerAccount?: PostingAccount;
  remittanceDocumentId?: number;
  remittanceDocument?: MediaFile;

  constructor(
    data: Partial<Model.IClaimJobPayment> | Utils.FormData<Model.IClaimJobPayment>,
    language?: Locale.Languages
  ) {
    super(
      {
        claimJobPaymentPayee: ClaimJobItemPayee,
        owner: User,
        claimJobPaymentItems: [ClaimJobPaymentItem],
        ledgerAccount: PostingAccount,
        remittanceDocument: MediaFile,
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.id?.toString(),
    };
  }

  static async find(params: { id: number }) {
    const { payload, ...rest } = await claimJobPaymentFindApi(params);
    return {
      ...rest,
      payload: new ClaimJobPayment(payload),
    };
  }

  static async list(body?: Api.Finance.ClaimJobPayment.List.IRequest) {
    const { payload, ...rest } = await claimJobPaymentListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new ClaimJobPayment(it)),
        count: payload.count,
      },
    };
  }

  static async cancel(params: { id: number }) {
    return await claimJobPaymentCancelApi(params);
  }
}
